import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NoticiasmoComponent} from "./noticiasmo.component";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [NoticiasmoComponent],
  exports: [NoticiasmoComponent]
})
export class NoticiasmoModule { }




// WEBPACK FOOTER //
// ./src/app/pages/noticiasmo/noticiasmo.module.ts